(function () {
  function onChange(event) {
    const radio = event.target;
    if (!radio.matches('[data-membership-plan]')) return;

    const form = radio.closest('[data-membership-select]');
    const attributeKey = form.dataset.attributeKey;
    const status = form.querySelector('[data-membership-status]');

    form.querySelectorAll('input[type="radio"]').forEach((input) => {
      input.disabled = true;
    });
    if (status) status.textContent = 'Saving your preference…';

    const attributes = {};
    attributes[attributeKey] = radio.value;

    fetch(window.routes.cart_update_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attributes }),
    })
      .then((response) => {
        if (!response.ok) throw new Error('Cart update failed');
        if (status) {
          status.textContent = `Saved — we'll remember you'd like the ${radio.value} plan.`;
        }
        form.querySelectorAll('input[type="radio"]').forEach((input) => {
          input.disabled = false;
        });
      })
      .catch(() => {
        if (status) {
          status.textContent = 'Something went wrong saving your preference — please try again.';
        }
        form.querySelectorAll('input[type="radio"]').forEach((input) => {
          input.disabled = false;
        });
      });
  }

  // The product page pre-selects a plan; save it so shoppers who keep the default still have one recorded.
  function saveDefault() {
    document.querySelectorAll('[data-membership-select][data-membership-default]').forEach((form) => {
      const radio = form.querySelector('[data-membership-plan]:checked');
      if (!radio) return;
      const attributes = {};
      attributes[form.dataset.attributeKey] = radio.value;
      fetch(window.routes.cart_update_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attributes }),
      }).catch(() => {});
    });
  }

  document.addEventListener('change', onChange);
  document.addEventListener('DOMContentLoaded', saveDefault);
})();
